import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import DatasetCardItems from './DatasetCardItems';

const DatasetCards = ({
  canCreate,
  handleScroll,
  items,
  itemsPerRow,
  newDatasetCode,
  onCheckBoxClick,
  readErrors,
  readStatus,
  showStatus,
  showTools,
  single,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-dataset-cards"
    entity="dataset"
    handleScroll={handleScroll}
    icon="table"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={codeUrl(urls.DATASET, newDatasetCode, '#')}
  >
    <DatasetCardItems
      items={items}
      onCheckBoxClick={onCheckBoxClick}
      single={single}
      showStatus={showStatus}
      showTools={showTools}
    />
  </InfiniteScrollCards>
);

export default DatasetCards;
